import type { BoardObject } from '../interfaces/board-object.interface.js';

/**
 * Per-page, in-memory clipboard shared by all whiteboards on the same
 * document. Holds deep copies so later mutations to the original objects
 * don't leak into a paste. Persists only for the lifetime of the page —
 * cross-tab / cross-session clipboards are out of scope.
 */
class Clipboard {
  private items: ReadonlyArray<BoardObject> = [];

  write(objects: ReadonlyArray<BoardObject>): void {
    // Structured clone keeps the clipboard isolated from later edits.
    this.items = objects.map((o) => structuredClone(o));
  }

  read(): ReadonlyArray<BoardObject> {
    return this.items.map((o) => structuredClone(o));
  }

  get isEmpty(): boolean { return this.items.length === 0; }
  get size(): number { return this.items.length; }
}

export const clipboard = new Clipboard();
